import React, { useEffect, useState } from "react";
import CommonList from "../common/CommonList";
import {
  apiCall,
  apiCallResponse,
  apiDownloadDocument,
} from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import {
  FilterContains,
  FilterContainsInsensitive,
  FilterContainsTwoField,
  FilterEqual,
} from "../common/FilterCondition";
import {
  CommonSearch,
  SCSelect,
  updateSearchStatus,
} from "../common/CommonSearch";
import CustomeModalPopup from "../common/CustomeModalPopup";
import TableButtonClick from "../common/Table/TableButtonClick";

const TransferLotList = () => {
  const [transferlotList, settransferlotList] = useState();
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false);
  const [pageLimit, setpageLimit] = useState(0);
  const [disabledprev, setdisabledprev] = useState(false);
  const [disablednext, setdisablednext] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [textField, settextField] = useState("lotNo");
  const [order, setorder] = useState("asc");
  // eslint-disable-next-line no-unused-vars
  const [orderClick, setOrderClick] = useState(true);
  const [itemPerPage, setItemPerPage] = useState(10);
  const { authenticated } = Auth();

  // popup Start

  const [refundopen, setrefundopen] = useState(false);
  //const [refundLotNo, setrefundLotNo] = useState(0);

  const [refundStatusList, setrefundStatusList] = useState();
  //Popup End
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage

  const SearchFilterModule = {
    collectionSeason:  new Date().getFullYear().toString(),
    tenderNo: "",
    emailId: "",
    lotNo: "",
    companyName: "",
    status: "",
    hoStatus: "",
  };

  // Search Model
  const [search, setSearch] = useState(SearchFilterModule);

  // useEffect(() => {
  //   orderClick ? setorder("asc") : setorder("desc");
  //   getTransferLotList();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageLimit, textField, orderClick, itemPerPage, authenticated]);

  useEffect(() => {
    setloading(true);
    reset();
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getTransferLotList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick, itemPerPage]);

  useEffect(() => {
    if (isSearch) {
      orderClick ? setorder("asc") : setorder("desc");
      getPageCount();
      getTransferLotList(true);
      setIsClear(false);
      setIsSearch(false);
      // reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  const paggingManage = (totalRecord, isRecordGet = true) => {
    if (isRecordGet === false) {
      setPageCount(0);
      paggingDisabled();
    } else {
      setPageCount(parseInt(totalRecord));
      paggingDisabled(
        pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
        pageLimit === 0
      );
    }
  };
  const fields = [
    {
      key: "lotNo",
      _style: { width: "7.5%" },
      label: "Lot No",
    },
    {
      key: "transferFrom",
      _style: { width: "20.5%" },
      label: "Transferor (1st Party)",
    },
    {
      key: "transferTo",
      _style: { width: "20.5%" },
      label: "Transferee (2nd Party)",
    },
    {
      key: "status",
      _style: { width: "5%" },
      label: "Status",
    },
    {
      key: "isReferToHo",
      _style: { width: "7.5%" },
      label: "IsRefer To Ho",
    },
    {
      key: "hoStatus",
      _style: { width: "5%" },
      label: "Ho Status",
    },
    // {
    //   key: "show_transfer_lot_details",
    //   label: "View",
    //   _style: { width: "1%" },
    //   sorter: false,
    //   filter: false,
    // },
    {
      key: "download_transfer_lot_details",
      label: "Download Transfer Letter",
      _style: { width: "10%" },
      sorter: false,
      filter: false,
    },
  ];

  //if (authenticated.role !== "Bidder") {
  fields.push({
    key: "Refund_History",
    label: "Refund Status",
    _style: { width: "10%" },
    sorter: false,
    filter: false,
  });
  //}

  const reset = () => {
    setpageLimit(0);
  };

  const filterManage = () => {
    let filter = "";
    filter = "&$filter=";
    filter = FilterContainsInsensitive(filter, "emailId", search.emailId);
    filter = FilterContainsInsensitive(filter, "lotNo", search.lotNo);

    filter = FilterContainsTwoField(
      filter,
      "transferFrom",
      "transferTo",
      search.companyName
    );
    filter = FilterContains(
      filter,
      "collectionSeason",
      search.collectionSeason
    );
    filter = FilterEqual(filter, "tenderNo", search.tenderNo);
    filter = FilterEqual(filter, "status", search.status);
    filter = FilterEqual(filter, "hoStatus", search.hoStatus);

    if (filter === "&$filter=") {
      filter = "";
    }
    return filter;
  };
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(
        `LotTransfer/gettransferlot?userid=${parseInt(
          authenticated.userId
        )}&role=${authenticated.role}${filterManage()}`
      ).then((res) => {
        if (res.success) paggingManage(parseInt(res.data.length) || 0);
        else paggingManage(0, false);
      });
    }
  };
  const getTransferLotList = async () => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `LotTransfer/gettransferlot?userid=${parseInt(
          authenticated.userId
        )}&role=${
          authenticated.role
        }&$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${parseInt(
          itemPerPage
        )}${filterManage()}`
      ).then((res) => {
        if (res.success) {
          settransferlotList(res.data);
          if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingManage(pageCount);
          }
        } else {
          settransferlotList();
          paggingManage(0, false);
        }
        setloading(false);
      });
    }
  };

  const ShowRefundHistory = async (lotno,tenderid) => {
    debugger;
    const header = new Headers();
    const response = await apiCall(
      `LotTransfer/GetRefundStatus?lotno=${lotno}&tenderid=${tenderid}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response.json();
    if (response.status === 200) {
      console.log(jsonobj);
      setrefundStatusList(jsonobj);
    }

    setrefundopen(true);
  };

  // const handleRefundPopupOpen = (lotno) => {
  //   setrefundopen(true);
  //   // setrefundLotNo(lotno);
  //   // getRefundStatus(lotno);
  // };

  const handleRefundPopupClose = () => setrefundopen(false);

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  const fieldsRefunds = [
    {
      key: "srno",
      label: "SRNO",
    },
    {
      key: "date",
      label: "Date",
    },
    {
      key: "beneficiary_bank_name",
      label: "Bank Name",
    },
    {
      key: "beneficiary_account_number",
      label: "Account Number",
    },
    {
      key: "beneficiary_bank_ifsc",
      label: "IFSC Code",
    },
    {
      key: "refund_percentage",
      label: "Lot %",
    },
    {
      key: "amount",
      label: "Amount",
    },
    {
      key: "status",
      label: "Status",
    },
    {
      key: "rejectionreason",
      label: "Comment/Reason",
    },
    {
      key: "download_Refund_lot_receipt",
      label: "Download Receipt",
    },
  ];
  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };
  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);

    setSearch({ ...search, ...SearchFilterModule });

    settransferlotList();
  };
  const statusList = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
  ];

  const hoStatusList = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
  ];

  /* */

  const SearchExtraControl = (
    <>
      <SCSelect
        labelname="Status"
        name="status"
        value={search.status}
        onChange={updateSearch}
        items={statusList}
      />
      <SCSelect
        labelname="HO Status"
        name="hoStatus"
        value={search.hoStatus}
        onChange={updateSearch}
        items={hoStatusList}
      />
    </>
  );
  const additional = (
    <CommonSearch
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      CompanyNameLabel={"Transferor / Transferee Name "}
      isCompanyNameDisplay={true}
      //isEmailAddressDisplay={true}
      extraControl={SearchExtraControl}
      isLotNumberDisplay={true}
    />
  );
  const DownloadTransferLetter = async (lotid, transferFromUserId) => {
    const header = new Headers();
    const url = "LotDetails/DownloadTransferLetter?lotid=" + Number(lotid);
    console.log("url : :", url);
    await apiDownloadDocument(
      lotid + "_" + transferFromUserId + ".pdf",
      url,
      "GET",
      header,
      null
    ).then((res) => {
      console.log("download : ", res);
      if (res.success) alert(res.message);
      else alert(res.message);
    });
  };

  const DownloadRefundReceipt = async (RefundId, SrNo) => {
    console.log("RefundId:", RefundId, "| SrNo: ", SrNo);
    const header = new Headers();
    const response = await apiCall(
      //`LotDetails/DownloadRefundReceipt?lotid=${Number(lotid)}&SrNo=${SrNo}`,
      `LotDetails/DownloadRefundReceipt?SrNo=${SrNo}&RefundId=${RefundId}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response;
    if (jsonobj.status === 200) {
      jsonobj.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = SrNo + ".pdf";
        alink.click();
      });
    }
  };
  let scopedSlotsList = {
    download_transfer_lot_details: (item, index) => {
      // let id;
      // if (props.path === "/transferlotdetails/") {
      //   id = window.btoa(item[props.id]);
      // } else {
      //   id = item[props.id];
      // }
      return (
        <>
          <TableButtonClick
            buttonName={" Download Transfer Letter"}
            isDisplayAllow={
              !(item.statusId === 1 && item.isCCFSignedAgreement === true)
            }
            onClick={() =>
              DownloadTransferLetter(item.lotId, item.transferFromUserId)
            }
          />
        </>
      );
    },
    Refund_History: (item, index) => {
      return (
        <TableButtonClick
          buttonName={"View Refund Status"}
          isDisplayAllow={true}
          onClick={() => ShowRefundHistory(item.lotNo,item.tenderid)}
        />
      );
    },
  };

  let refundScopedSlotsList = {
    download_Refund_lot_receipt: (item, index) => {
      return (
        <>
          <TableButtonClick
            buttonName={" Download Refund Receipt"}
            isDisplayAllow={true}
            onClick={() => DownloadRefundReceipt(item.id, item.srno)}
          />
        </>
      );
    },
  };
  return (
    <>
      <CommonList
        items={transferlotList}
        fields={fields}
        listName="Lot Transfer List"
        loading={loading}
        path="/transferlotdetails/"
        tabBtn="View"
        tabdownloadtransferlatterBtn="Download Transfer Latter"
        additional={additional}
        prev={prevButton}
        next={nextButton}
        disabledprev={disabledprev}
        disablednext={disablednext}
        id="lotId"
        ShowRefundHistory={(id) => {
          ShowRefundHistory(id);
        }}
        scopedSlots={scopedSlotsList}
      />
      <div>
        <CustomeModalPopup
          onOpen={refundopen}
          onClose={handleRefundPopupClose}
          onCloseButton={handleRefundPopupClose}
          popupWith={"90%"}
          body={
            <CommonList
              items={refundStatusList}
              fields={fieldsRefunds}
              listName="Refund History"
              loading={false}
              disabledprev={true}
              disablednext={true}
              displayPaggingButton={false}
              scopedSlots={refundScopedSlotsList}
            />
          }
          isSubmitBtnDisabled={false}
          disabledBtn={false}
          btnSubmitShow={false}
          btnCloseText={"Close"}
          btnCloseShow={true}
          btnCColClass={"text-right"}
          heightSet={"auto"}
        />
      </div>
    </>
  );
};

export default TransferLotList;
